<template>
		<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>

		<div class="d-flex h-full flex-column">
				<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
	<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
	<div class="container pdt-50">
					<div class="t-color-headlineBlack t-headline15 font-b">{{$t('3202')}}</div>
					<div class="divider mgt-24"></div>
	</div>
	<div class="container main-swiper-container main-swiper mgt-24 pdb-50">
					<div class="d-flex mgb-16 flex-wrap"  v-if="popularTag && popularTag.length">
						<template 	v-for="(tag, index) in popularTag">
									<div
									:key="index"
									v-if="firstSelectedTags.includes(tag.id)"
									class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center">
													#{{tag.name}}
									</div>
									</template>
					</div>
				<div class="container  main-swiper-container main-swiper" v-if="examIndependentData && examIndependentData.content && examIndependentData.content.length">
					<div class="d-grid-3-24 pda-4">
						<div v-for="(examData, indexExam) in examIndependentData.content" :key="indexExam+'_exam'">
							<div class="mdc-card cursor-pointer" @click="viewDetailExam(examData.id)" @keypress="viewDetailExam(examData.id)" tabindex="0">
								<div class="mdc-card__primary-action" tabindex="0">
									<div class=" position-relative" v-if="examData.image">
											<div class="pdl-24 pdr-24 pdt-24">
													<img :src="examData.image" alt="" class="test-carousel-image">
											</div>
											<div class="mdc-chip-set swiper-chip test-swiper-chip" role="grid">
												<div class="mdc-chip h-32 t-line-h-initial" role="row">
														<div class="mdc-chip__ripple"></div>
														<span role="gridcell">
															<span role="button" tabindex="0" class="mdc-chip__primary-action">
																<span class="mdc-chip__text t-body3 pdt-4 pdb-4 t-color-white font-rn">
																	{{indexExam+1}}/{{examIndependentData.content.length}}
																	</span>
															</span>
														</span>
												</div>
											</div>
									</div>
									<div class="mgt-24 ">
										<div class="t-headline7 pdl-24 pdr-24 font-m t-line-h-28 mgb-24">
											{{ examData.name }}
										</div>
										<div class="d-flex align-items-baseline pdl-24 pdb-24" v-if="examData.goods && examData.goods.paymentPrice > 0">
											<div class="t-color-headlineBlack t-body-6 pdr-4 d-flex align-items-baseline">{{examData.goods.currency.key || 'USD'}} <div class="t-color-headlineBlack t-headline10 pdl-8">{{$n(examData.goods.paymentPrice)}}</div></div>
											<div class="t-body1 t-color-bodyGrayB t-line-through-red" v-if="examData.goods.paymentPrice < examData.goods.price">{{$n(examData.goods.price)}}</div>
										</div>
										<div class="d-flex align-items-baseline pdl-24 pdb-24" v-else>
											<div class="t-color-headlineBlack t-headline10 pdr-8">Free</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</main>
		</div>
		</div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import {mapState} from 'vuex'


export default {
	name: "TagSerachCourse",
	components: {
		TopAppBar,
		TopAppBarDrawer,

	},
		data() {
		return {
			popularTag : null,
   examIndependentData : null,
			firstSelectedTags:[]
		};
	},

	computed: {

	},

	mixins: [topAppBarMixin],
	mounted() {
		this.firstSelectedTags = this.$route.query.tags.split(",").map(Number);
  // fetch all tags data
			mainApi
			.fetchPopularTag()
			.then((response) => {
				this.popularTag = response.data.data;
			})
			.catch((err) => { });
			let params = {size: 10, tags: this.$route.query.tags}
				 		mainApi.fetchPopularTagExam(params)
			.then((response) => {
				this.examIndependentData = response.data.data;
			})
			.catch((err) => {
				responseData = err.response.data.meta;
				this.$error({ content: responseData.errMsg }).then(() => {});
			});
	},
				// Move to exam detail based id
					viewDetailExam(id) {
					this.$router.push({
						name: "IndependentExamTotalView",
						params: { distId: id }
					});
					}
}
</script>
